export const name = '@lifi/sdk';
export const version = '3.6.2';
//# sourceMappingURL=version.js.map